import { createRoot } from 'react-dom/client';
import * as React from 'react';
import { ThemeOptions, ThemeProvider, createTheme } from '@mui/material/styles';
import AppRouter from './Router';
import { BrowserRouter } from 'react-router-dom';
import { MuiBlackBoxTheme } from './global-styles/MuiBlackBoxTheme';
import Notifier from './components/Snackbar/SnackBar';
import SnackBarWrapper from './components/Snackbar/SnackBarWrapper';
import { history } from './helpers/history';

import { Provider } from 'react-redux';
import reduxStore from './configs/ReduxStore';

import './global-styles/global.pcss';
import './analytics.js';

const theme = createTheme(MuiBlackBoxTheme as ThemeOptions);

window.onload = () => {
  const container = document.getElementById('root');
  if (!container) {
    throw new Error('Root container not found');
  }

  const root = createRoot(container);

  root.render(
    <Provider store={reduxStore}>
      <ThemeProvider theme={theme}>
        <SnackBarWrapper>
          <Notifier />
        </SnackBarWrapper>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
      </ThemeProvider>
    </Provider>
  );
};
